module.exports = __webpack_public_path__ + "static/media/imageStep2.b481fb13.svg";